export const LANG = {
  JAPANESE: 'ja',
  ENGLISH: 'en',
  SIMPLE_CHINESE: 'zh-CN',
  TRADITIONAL_CHINESE: 'zh-TW',
  KOREAN: 'ko',
  VIETNAM: 'vi',
  THAILAND: 'th',
} as const;
